import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import moment from 'moment'

import Action from '@components/Action'
import Download from '@components/Icon/Download'
import { invoiceApi } from '@atheneum/api'
import { downloadFromUrl, exportDialogMessage, tokenStorage } from '@atheneum/api/dist/lib'

class Actions extends Component {
  static propTypes = {
    type: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    queueProcessorStore: PropTypes.object,
    unpaidOnly: PropTypes.bool
  }

  exportToExcel = async (type, startDate, endDate, unpaidOnly) => {
    const filename = `${type}_invoice_export_${moment().format(
      'DD.MM.YYYY'
    )}.xlsx`

    const { jobId } = await invoiceApi.exportAllInvoices({
      export: type,
      startDate,
      endDate,
      unpaidOnly
    }).catch(() => alert('export error'))

    this.props.queueProcessorStore.trackJob(jobId, ({ url }) =>
      downloadFromUrl({ url: `${url}?token=${tokenStorage.get()}`, filename })
    )

    this.job = this.props.queueProcessorStore.jobs[jobId]

    if (this.job && this.job.loading) {
      this.exportInProgress = true
      setTimeout(() => {
        this.exportInProgress = false
      }, 1000)
    }

    await exportDialogMessage({ exportType: 'invoice report' })
  }

  render () {
    const { type, startDate, endDate, unpaidOnly } = this.props
    return (
      <ul className='actions right-list'>
        <li
          className='action'
          onClick={() => {
            this.exportToExcel(type, startDate, endDate, unpaidOnly)
          }}
        >
          <Action>
            <Download />
            <span>Export</span>
          </Action>
        </li>
      </ul>
    )
  }
}

export default inject('queueProcessorStore')(observer(Actions))
